<template>
    <div class="d-block" v-if="detailedItem.id">
        <div class="row">
            <div class="col-md-2">
                <ul class="parent_item_block d-none d-sm-block nav fa-ul">
                    <li class="parent_item nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#finance-operation"><span class="fa-li"><i class="fas fa-chevron-right"></i></span> Детали</a>
                    </li>
                    <li class="parent_item nav-item">
                        <a class="nav-link" data-toggle="tab" href="#finance-payments"><span class="fa-li"><i class="fas fa-chevron-right"></i></span> Платежи</a>
                    </li>
                    <li class="parent_item nav-item">
                        <a class="nav-link" data-toggle="tab" href="#finance-requests"><span class="fa-li"><i class="fas fa-chevron-right"></i></span> Запросы</a>
                    </li>
                    <li class="parent_item nav-item">
                        <a 
                            class="nav-link" 
                            data-toggle="tab" 
                            href="#finance-documents"
                        >
                            <span class="fa-li"><i class="fas fa-chevron-right"></i></span> Документы</a>
                    </li>
                    <li class="parent_item nav-item">
                        <a 
                            class="nav-link" 
                            data-toggle="tab" 
                            href="#finance-tasks"
                        >
                        <span class="fa-li"><i class="fas fa-chevron-right"></i></span> 
                        Задачи
                        </a>
                    </li>
                    <!--                            <li class="parent_item nav-item">-->
                    <!--                                <a-->
                    <!--                                    class="nav-link"-->
                    <!--                                    data-toggle="tab"-->
                    <!--                                    href="#change-history"-->
                    <!--                                    @click="changeLoad = !changeLoad"-->
                    <!--                                >-->
                    <!--                                    <span class="fa-li"><i class="fas fa-chevron-right"></i></span>-->
                    <!--                                    История-->
                    <!--                                </a>-->
                    <!--                            </li>-->
                </ul>
            </div>
            <div class="col-md-10">
                <div class="tab-content">
                    <div class="tab-pane fade show active" id="finance-operation">
                        <tsoft-finance-details
                            :detailed-item="detailedItem"
                            :additional-data="additionalData"
                            @updateParentData="updateParentData"
                        ></tsoft-finance-details>
                    </div>
                    <div class="tab-pane fade" id="finance-payments">
                        <h5 class="mb-4">Платежи по счету #{{detailedItem.invoice_number || "{УКАЖИТЕ_НОМЕР_СЧЕТА}"}}</h5>
                        <tsoft-finance-payments
                            :finance_id="detailedItem.id"
                            :additionalGetParameter="`&finance_id=${detailedItem.id}`"
                            :isNeedCreate="isAgent ? false : true"
                            :isNeedSubtotal="true"
                            :isCurrencyOperation="detailedItem.reference_currency_id == 122 ? false : true"
                            :sumRubles="detailedItem.sum || 0"
                            :financePaymentDetails="detailedItem"
                            @updateParentData="updateParentData"
                            @updateCurrencyPayments="updateCurrencyPayments"
                        />
                    </div>
                    <div class="tab-pane fade" id="finance-requests">
                        <h5 class="mb-4">Запросы по счету #{{detailedItem.invoice_number || "{УКАЖИТЕ_НОМЕР_СЧЕТА}"}}</h5>
                        <tsoft-finance-requests-by-parameters
                            :additionalGetParameter="`&finance_id=${detailedItem.id}`"
                            :isNeedCreate="true"
                            :createRequestObject="{ order_id: detailedItem.order_id,
                                                        company_id: detailedItem.external_company_id || detailedItem.order.company_id,
                                                        finance_id: detailedItem.id,
                                                        order_service_id: detailedItem.order_service_id }"
                        />
                    </div>
                    <div class="tab-pane fade" id="finance-documents">
                        <h5>Документы по счету #{{detailedItem.invoice_number || "{УКАЖИТЕ_НОМЕР_СЧЕТА}"}}</h5>
                        <tsoft-show-edit-documents
                            :financeId="detailedItem.id"
                            :requestDocuments="detailedItem.id ? true : false"
                            :updateListDocument="singleOrMultiDocuments"
                            @clearDocumentList="clearDocumentList"
                        />
                        <tsoft-create-documents
                            :orderId="detailedItem.order_id"
                            :orderServiceId="detailedItem.order_service_id"
                            :companyId="detailedItem.external_company_id || detailedItem.order.company_id"
                            :financeId="detailedItem.id"
                            :needMultiUploadDocuments="true"
                            @updateViewDocument="documentOutput"
                        />
                    </div>
                    <div class="tab-pane fade" id="finance-tasks">
                        <h5 class="mb-4">Задачи по счету #{{detailedItem.invoice_number || "{УКАЖИТЕ_НОМЕР_СЧЕТА}"}}</h5>
                        <tsoft-history-task
                            :modelName="'finance_id'"
                            :modelId="detailedItem.id"
                            :changeLoadTaskList.sync="changeLoad"
                        />
                    </div>
                    <!--                            <div class="tab-pane fade" id="change-history">-->
                    <!--                                <tsoft-change-history-->
                    <!--                                    :changeHistoryId.sync="detailedItem.id"-->
                    <!--                                    :changeModel.sync="model_name"-->
                    <!--                                    :changeLoad.sync="changeLoad"-->
                    <!--                                />-->
                    <!--                            </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import tsoftFinanceDetails from './FinanceDetails'
import tsoftFinanceRequestsByParameters from './FinanceRequestsByParameters'
import tsoftFinancePayments from './FinancePaymentsFinderAndCreator'
import { mixinDocuments } from '../../mixins/mixinDocuments'
import { actionShowItem } from '../../mixins/actions'
import { API_FINANCE } from "../../constants"

export default {
    components: {
        'tsoft-finance-details': tsoftFinanceDetails,
        'tsoft-finance-requests-by-parameters': tsoftFinanceRequestsByParameters,
        'tsoft-finance-payments': tsoftFinancePayments
    },
    mixins: [
        mixinDocuments,
        actionShowItem
    ],
    props: {
        financeId: {
            type: Number,
            required: true
        },
        changeLoad: {
            type: Boolean, 
            default: false
        }
    },
    data() {
        return {
            additionalData: {
                paidSumCurrency: 0
            }
        }
    },
    computed: {
        ...mapGetters('auth', ['currentUser']),
        isAgent() {
            return this.currentUser.role.includes('agent');
        }
    },
    mounted() {
        this.loadOneItem();
    },
    methods: {
        updateCurrencyPayments(sum) {
            this.additionalData.paidSumCurrency = sum
        },
        updateParentData() {
            this.$emit('updateOpenedData')
        },
        loadOneItem() {
            api.call("get", `${API_FINANCE}/${this.financeId}`).then(({data}) => {
                this.detailedItem = data;
                this.loading = false;
            })
        }
    },
}
</script>
